import { Box, BoxProps, ColorOptions, Icon, Spacer, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { useNavigation } from '@react-navigation/core'
import { useEffect, useState } from 'react'
import { FlatList } from 'react-native'
import XlsxPopulate from 'xlsx-populate'
import { TextInputWithCb } from '../../components/TextInputWithCb'
import { useLazyApiData, useStores } from '../../data/store'
import { convertCamelCaseToString, isAccessible } from '../../utils'
import { AddNewMappingForm } from './AddNewMappingForm'

const LedgerMappingDetails = (props: any) => {
  const { route } = props
  const { id } = route?.params ?? {}
  localStorage.setItem('params', id)
  const { merchantData } = useStores((store) => ({
    merchantData: store.ledgerMapping.getMerchant,
  }))

  const [isEditable, setIsEditable] = useState(false)

  const data: any = merchantData(isEditable)

  const renderItem = ({ item }: any) => {
    return (
      <Box p={16} f={1}>
        <TextInputWithCb
          label={convertCamelCaseToString(item)}
          value={data[item] ?? ''}
          onChange={() => {}}
          showCheckbox={false}
        />
      </Box>
    )
  }

  const keyExtractor = (item: any): string => {
    return item?.id
  }

  const navigation = useNavigation()
  const handleOnUpdateSuccess = () => {
    setIsEditable(false)
    navigation.navigate('ledgermapping')
  }

  const exportFile = async (listData: any) => {
    let transformedData: any = []
    const filteredData = listData.map((item: any) => {
      return {
        id: id,
        merchantId: item.merchantId,
        entityID: item.entityID,
        txnType: item.txnType,
        instrumentType: item.instrumentType,
        meCode: item.meCode,
        reqType: item.reqType,
        pgSecurityId: item.pgSecurityId,
        secret: item.secret,
        chiper: item.chiper,
        mcfg1: item.mcfg1,
        mcfg2: item.mcfg2,
        emiCode: item.emiCode,
        mappingStatus: item.mappingStatus,
      }
    })
    transformedData = filteredData.map((item: any) => [
      id,
      item?.merchantId,
      item?.ledgerAcctNumber,
      item?.mappingStatus,
    ])

    const inputKeys = ['id', 'merchantId', 'ledgerAcctNumber', 'mappingStatus']

    XlsxPopulate.fromBlankAsync().then(async (workbook: any) => {
      const data: any = []
      data.push([...inputKeys])

      filteredData.map((item: any, index: number) => {
        data.push([...Object.values(item), ...transformedData[index]])
      })

      workbook.sheet(0)?.cell('A1')?.value(data)

      const blob = await workbook.outputAsync({
        type: 'blob',
      })

      var url = window.URL.createObjectURL(blob as Blob)
      var a = document.createElement('a')
      document.body.appendChild(a)
      a.href = url
      a.download = 'merchant_ledger_mapping_file.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
  }

  return (
    <Box>
      <Text title={'Ledger Mapping Details'} fontSize={28} fontWeight={'600'} color={'#5a5c69' as ColorOptions} />
      <Box {...styles.header} bg={'#f8f9fc' as ColorOptions} paddingVertical={16} justify={'flex-end'}>
        <ButtonNew
          title={'Export To Excel'}
          onPress={() => exportFile([data])}
          height={32}
          borderRadius={4}
          hoverColor={'DARK_OCEAN_BLUE'}
        />
        <Spacer direction={'horizontal'} size={16} />
        <Box
          flexDirection="row"
          backgroundColor={isEditable ? 'RED' : 'ORANGE'}
          padding={8}
          borderRadius={4}
          onPress={() => setIsEditable((prev) => !prev)}
          underlayColor={isEditable ? 'RED' : 'YELLOW'}>
          {!isEditable && <Icon id="EDIT" size="FONT_SIZE_LARGE" color="WHITE" />}
          {!isEditable && <Spacer direction="horizontal" size={4} />}
          <Text color="WHITE" fontFamily={'jiotype-medium'}>
            {isEditable ? 'Cancel' : 'Edit'}
          </Text>
        </Box>
      </Box>
      {!isEditable && (
        <Box {...styles.container}>
          <FlatList data={Object.keys(data)} renderItem={renderItem} numColumns={4} keyExtractor={keyExtractor} />
        </Box>
      )}
      {isEditable && <AddNewMappingForm id={id} isEditable={true} isDeletable={false} />}
    </Box>
  )
}

export default LedgerMappingDetails
const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  container: {
    ...shadow,
    borderWidth: 1,
    borderTopWidth: 0,
    borderBottomRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderColor: '#e3e6f0' as ColorOptions,
    flexDirection: 'row',
    flexWrap: 'wrap',
    p: 8,
  } as BoxProps,
  header: {
    ...shadow,
    marginTop: 16,
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 14,
    borderWidth: 1,
    borderRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
}
